import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    async fetchCardsBatch() {
      return axiosIns.get('vouchers/cards/batch')
    },
    async downloadBatch(_, id) {
      return axiosIns.get(`vouchers/cards/batch/${id}/download`)
    },
  },
}
